import {
  GWT_GET_APPLICATION_ID_FAILED,
  GWT_GET_APPLICATION_ID_START,
  GWT_GET_APPLICATION_ID_SUCCESS,
  SET_IS_MESSAGE_FORM_DIRTY,
  SHOW_CHICKEN_EXIT,
  SET_FIND_RECORDING_MODAL_LANG,
  SET_FIND_RECORDING_FIELD_ID,
} from 'actions/messages';

const defaultState = {
  showChickenExit: false,
  isMessageFormDirty: false,
  setFindRecordingLanguage: null,
  setFindRecordingFieldId: null,
  setTranslationFieldId: null,
  setTranslationFieldName: null,
  setTranslationFieldLang: null,
  applicationIds: {
    loading: false,
    applicationId: null,
    applicationUuid: null,
  },
};

export default function messages(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case GWT_GET_APPLICATION_ID_SUCCESS:
      if (payload) {
        const { longId, uuid } = payload;
        return {
          ...state,
          applicationIds: {
            loading: false,
            applicationId: longId,
            applicationUuid: uuid,
          },
        };
      }
      return state;

    case GWT_GET_APPLICATION_ID_START:
      return {
        ...state,
        applicationIds: {
          ...state.applicationIds,
          loading: true,
        },
      };

    case GWT_GET_APPLICATION_ID_FAILED:
      return {
        ...state,
        applicationIds: {
          ...state.applicationIds,
          loading: false,
        },
      };

    case SHOW_CHICKEN_EXIT: {
      return {
        ...state,
        showChickenExit: payload,
      };
    }

    case SET_IS_MESSAGE_FORM_DIRTY: {
      return {
        ...state,
        isMessageFormDirty: payload,
      };
    }

    case SET_FIND_RECORDING_MODAL_LANG: {
      return {
        ...state,
        setFindRecordingLanguage: payload,
      };
    }
    case SET_FIND_RECORDING_FIELD_ID: {
      return {
        ...state,
        setFindRecordingFieldId: payload,
      };
    }
    default:
      return state;
  }
}
